import _ from 'lodash'
import { Line } from 'react-chartjs-2'
import type { ChartData } from 'chart.js'

export function StackedAreaChart({
  title,
  chartData,
  yScaleIsPercentages,
}: {
  title: string
  chartData: ChartData<'line'>
  yScaleIsPercentages?: boolean
}) {
  const data = {
    ...chartData,
    datasets: chartData.datasets.map((dataset) => ({ ...dataset, fill: true })),
  }

  return (
    <div className="w-full">
      <div className="font-mono mb-2">{title}</div>
      <Line
        data={data}
        options={{
          responsive: true,
          interaction: { mode: 'index', intersect: false },
          elements: { point: { radius: 0 } },
          plugins: {
            legend: {
              position: 'bottom',
              reverse: true,
            },
            tooltip: {
              itemSort: (a, b) => b.datasetIndex - a.datasetIndex,
              callbacks: {
                footer: (items) => {
                  if (yScaleIsPercentages) return ''
                  const total = _.sumBy(items, (item) => item.parsed.y ?? 0)
                  return `Total: ${total.toLocaleString('fi-FI')}`
                },
              },
            },
          },
          scales: {
            x: { stacked: true },
            y: {
              stacked: true,
              beginAtZero: true,
              max: yScaleIsPercentages ? 100 : undefined,
              ticks: {
                precision: 0,
                format: yScaleIsPercentages ? { style: 'unit', unit: 'percent', maximumFractionDigits: 2 } : undefined,
              },
            },
          },
        }}
      />
    </div>
  )
}
